// noinspection DuplicatedCode

import settings from '@settings'
import i18next from 'i18next'
import ChainedBackend from 'i18next-chained-backend'
import HttpBackend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

// noinspection SpellCheckingInspection
const options = {
  debug: false,
  lng: 'en',
  fallbackLng: 'en',
  supportedLngs: ['en-US', ...settings.languages],
  ns: 'translation',
  defaultNS: 'translation',
  interpolation: { escapeValue: false },
  react: {
    useSuspense: true
  },
  backend: {
    backends: [HttpBackend],
    backendOptions: [{ loadPath: `/i18n/{{lng}}.json` }]
  }
}

void i18next.use(ChainedBackend).use(initReactI18next).init(options)
